import Vue from 'vue';

const DEFAULT_TEMPLATE = 'default';

Vue.mixin({
  computed: {
    domain() {
      return window.location.origin;
    },
    pages() {
      const pages = [
        {
          order: 3,
          path: this.i18nLink('my-photos'),
          name: this.$t('my_photos'),
          lockIcon: true,
        },
        {
          order: 4,
          path: this.i18nLink('contact'),
          name: this.$tc('contact', 1),
        },
      ];

      if (this.coreParams.shop_design.homepage === 'text_page') {
        pages.push({
          order: 1,
          path: this.i18nLink('/'),
          name: this.$t('home'),
        });
      }

      pages.push({
        order: 2,
        path: this.i18nLink(this.coreParams.shop_design.homepage === 'standard' ? 'gallery' : 'album'),
        name: this.$t(
            this.coreParams.shop_design.homepage === 'text_page'
                ? 'gallery' : 'home'),
      });

      return this._.orderBy(pages, 'order');
    },
    accountPages() {
      return [
        {
          path: this.i18nLink('account/profile'),
          name: this.$t('account.profile'),
        },
        {
          path: this.i18nLink('account/invoices'),
          name: this.$t('account.invoices'),
        },
        {
          path: this.i18nLink('account/personal_albums'),
          name: this.$t('account.personal_albums'),
        },
        {
          path: this.i18nLink('account/downloads'),
          name: this.$t('account.downloads'),
        },
      ];
    },
    filters() {
      return [
        {
          'name': 'lavender',
          'modifiers': [
            {
              'name': 'grayscale',
              'value': '25%',
            },
            {
              'name': 'sepia',
              'value': '0.25',
            },
            {
              'name': 'brightness',
              'value': '110%',
            },
            {
              'name': 'contrast',
              'value': '130%',
            },
          ],
        },
        {
          'name': 'black-and-white',
          'modifiers': [
            {
              'name': 'grayscale',
              'value': '100%',
            },
            {
              'name': 'brightness',
              'value': '110%',
            },
            {
              'name': 'contrast',
              'value': '110%',
            },
          ],
        },
        /*{
          'name': 'duotone',
          'modifiers': [
            {
              'name': 'grayscale',
              'value': '100%',
            },
            {
              'name': 'sepia',
              'value': '0.6',
            },
            {
              'name': 'brightness',
              'value': '105%',
            },
            {
              'name': 'contrast',
              'value': '120%',
            },
            {
              'name': 'hue-rotate',
              'value': '160deg',
            },
          ],
        },*/
      ];
    },
    hasPoweredBy() {
      if (this.coreParams.current_shop_package &&
          this.coreParams.current_shop_package.shop_package &&
          this.coreParams.current_shop_package.shop_package.whitelabel) {
        return !+this.coreParams.current_shop_package.shop_package.whitelabel;
      }

      return true;
    },
  },
  methods: {
    getTemplateName() {
      switch (this.coreParams.theme_name) {
        case DEFAULT_TEMPLATE:
          return DEFAULT_TEMPLATE;
        case 'other':
        case 'templates':
          return this.coreParams.theme_name;
        default:
          return DEFAULT_TEMPLATE;
      }
    },
    striptags(str) {
      return str.replace(/(<([^>]+)>)/ig, '');
    },
    applyFilter(el, filter) {
      if (el) {
        let values = [];

        if (filter) {
          filter.modifiers.forEach(modifier => {
            values.push(`${modifier.name}(${modifier.value})`);
          });

          el.style.filter = values.join(' ');
        } else {
          el.style.filter = null;
        }
      }
    },
    reloadAlbum() {
      this.$store.dispatch('SET_RENDER_ALBUM', false);

      this.$nextTick().then(() => {
        this.$store.dispatch('SET_RENDER_ALBUM', true);
      });
    },
    downloadPhotos(id) {
      const form = document.createElement('form');
      form.target = '_blank';

      if (typeof id === 'object') {
        if (id.length === 1) {
          id = this._.first(id).photoId;
        } else {
          form.method = 'POST';
          form.action = `${this.apiUrl}v2/album_items/download`;

          id.forEach(item => {
            if (item.photoId) {
              const input = document.createElement('input');
              input.type = 'hidden';
              input.name = 'ids[]';
              input.value = item.photoId;
              form.appendChild(input);
            }
          });
        }
      }

      if (typeof id === 'string' || typeof id === 'number') {
        form.method = 'GET';
        form.action = `${this.apiUrl}v2/album_items/${id}/download`;
      }

      document.body.appendChild(form);
      form.submit();
      form.remove();
    },
    getPhotoClientWidth(isAlbumPage = false) {
      let cols, offset = 0, containerWidth = document.querySelector('.container')
          ? document.querySelector('.container').clientWidth : window.innerWidth;

      if (this.isMobile) {
        if (window.innerWidth >= 768) {
          offset = isAlbumPage ? 27 : 18;
          cols = isAlbumPage ? 3 : 4;
        } else {
          offset = isAlbumPage ? 30 : 25;
          cols = 2;
        }
      } else {
        cols = isAlbumPage ? 3 : 5;
        offset = isAlbumPage ? this.coreParams.theme_settings.sidebar ? 40 : 24 : 26;
      }

      if (containerWidth) {
        return parseInt(containerWidth / cols - offset);
      }

      return 0;
    }
  },
});

